<template>
  <div class="user-edit-modal" ref="userEditModal">
    <artmisads-modal :open="true" title="Edit" :width="480" :getContainer="() => $refs.userEditModal"
      @cancel="emit('update:visible', false)">
      <div class="user-info" v-if="info.sellerName">{{ info.sellerName }}<em>{{ info.email }}</em></div>
      <div class="user-info" v-else>{{ info.creatorName }}</div>
      <a-form :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="BD">
          <artmisads-input v-model:value="form.bd" />
        </a-form-item>
        <a-form-item label="Referral" class="referral-item">
          <artmisads-input v-model:value="form.referral" />
        </a-form-item>
          <a-form-item label="tag1" class="referral-item">
          <artmisads-input v-model:value="form.tag1" />
        </a-form-item>
          <a-form-item label="tag2" class="referral-item">
          <artmisads-input v-model:value="form.tag2" />
        </a-form-item>
          <a-form-item label="tag3" class="referral-item">
          <artmisads-input v-model:value="form.tag3" />
        </a-form-item>
          <a-form-item label="tag4" class="referral-item">
          <artmisads-input v-model:value="form.tag4" />
        </a-form-item>
          <a-form-item label="tag5" class="referral-item">
          <artmisads-input v-model:value="form.tag5" />
        </a-form-item>
      </a-form>
      <template #footer>
        <artmisads-button type="default" :isSquare="true"
          @click="emit('update:visible', false)">Cancel</artmisads-button>
        <artmisads-button type="primary" :isSquare="true" @click="handleOk">Save</artmisads-button>
      </template>
    </artmisads-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { operatorSellerApi } from '~/server/index';

const loading = ref(false);
const props = defineProps({
  info: {
    type: Object,
    default: () => ({}),
  },
});
console.log(props.info,'props.info');
const form = ref({
  bd: props.info.bd || '',
  referral: props.info.referral || '',
  tag1: props.info.userType === 'seller' ? JSON.parse(props.info?.tags || '{}')?.tag1 || '' : props.info?.tags?.tag1 || '',
  tag2: props.info.userType === 'seller' ? JSON.parse(props.info?.tags || '{}')?.tag2 || '' : props.info?.tags?.tag2 || '',
  tag3: props.info.userType === 'seller' ? JSON.parse(props.info?.tags || '{}')?.tag3 || '' : props.info?.tags?.tag3 || '',
  tag4: props.info.userType === 'seller' ? JSON.parse(props.info?.tags || '{}')?.tag4 || '' : props.info?.tags?.tag4 || '',
  tag5: props.info.userType === 'seller' ? JSON.parse(props.info?.tags || '{}')?.tag5 || '' : props.info?.tags?.tag5 || '',
});

const emit = defineEmits(['update:visible']);

function handleOk() {
  if (!loading.value) {
    loading.value = true;
    const tags = JSON.stringify({
      tag1: form.value.tag1,
      tag2: form.value.tag2,
      tag3: form.value.tag3,
      tag4: form.value.tag4,
      tag5: form.value.tag5,
    })
    const param={
      bd: form.value.bd,
      referral: form.value.referral,
      tags,
    }
    operatorSellerApi.updateUserInfo(props.info.id, props.info.userType, param).then(res => {
      loading.value = false;

      if (res.success) {
        emit('update:visible', props.info.index, form.value);
      }
    });
  }
}
</script>

<style lang="less" scoped>
.user-edit-modal {
  :deep(.ant) {
    &-form-item-label>label {
      height: 40px;
    }
  }
}

.user-info {
  display: flex;
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  margin-bottom: 16px;

  em {
    font-size: 14px;
    margin-left: 10px;
    font-style: normal;
    font-weight: normal;
    color: var(--dark-3);
  }
}

.referral-item {
  margin-bottom: 24px;
}
</style>
